// extracted by mini-css-extract-plugin
export var marginNegative = "_5k-5 _5k-3 _5k-1";
export var marginPositive = "_5k-4 _5k-3 _5k-1";
export var modalContent = "_5k-6";
export var samplesTable = "_5k-8";
export var samplesTableContainer = "_5k-7";
export var statBox = "_5k-a";
export var tableCell = "_5k-1";
export var tableCellCenter = "_5k-2 _5k-1";
export var tableCellRight = "_5k-3 _5k-1";
export var tableHeader = "_5k-0";
export var trackingNumber = "_5k-9";